/* eslint-disable class-methods-use-this */
import {
  Message,
  MessageAPI,
} from 'utils/__interfaces/SuperAdministration/Message'

class MessageTableNormalizer {
  normalize(tableMessages: MessageAPI[]): Message[] {
    return tableMessages.map((item) => {
      return this.normalizeSingle(item)
    })
  }

  normalizeSingle(message: MessageAPI): Message {
    return {
      id: message.id,
      statut: message.statut,
      messagetext: message.messagetext,
      source: message.source ?? '',
      createdAt: message.createdAt ? new Date(message.createdAt) : undefined,
      expireAt: message.expireAt ? new Date(message.expireAt) : undefined,
      contracts: message.contrats,
      users: message.users.map((element) => {
        return element.user
      }),
    }
  }
}

export default new MessageTableNormalizer()
